import type { ApiClient } from './client';

export type CannedScope = 'personal' | 'shared';

export interface CannedResponse {
  id: string;
  scope: CannedScope;
  operatorId: string | null;
  title: string;
  body: string;
  shortcut: string | null;
  createdAt: string;
  updatedAt: string;
}

interface RawCanned {
  id: string;
  scope: 'personal' | 'shared';
  operator_id: string | null;
  title: string;
  body: string;
  shortcut: string | null;
  created_at: string;
  updated_at: string;
}

function toCanned(r: RawCanned): CannedResponse {
  return {
    id: r.id,
    scope: r.scope,
    operatorId: r.operator_id,
    title: r.title,
    body: r.body,
    shortcut: r.shortcut,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
  };
}

export async function listCannedResponses(client: ApiClient): Promise<CannedResponse[]> {
  const raw = await client.request<{ canned_responses: RawCanned[] }>('/api/v1/canned_responses');
  return raw.canned_responses.map(toCanned);
}

export interface CreateCannedInput {
  title: string;
  body: string;
  shortcut?: string | null;
  scope?: CannedScope;
}

export async function createCannedResponse(
  client: ApiClient,
  input: CreateCannedInput,
): Promise<CannedResponse> {
  const raw = await client.request<RawCanned>('/api/v1/canned_responses', {
    method: 'POST',
    json: input,
  });
  return toCanned(raw);
}

export interface UpdateCannedInput {
  title?: string;
  body?: string;
  /** `null` — очистить shortcut; `undefined` — не менять. */
  shortcut?: string | null;
}

export async function updateCannedResponse(
  client: ApiClient,
  id: string,
  input: UpdateCannedInput,
): Promise<CannedResponse> {
  const raw = await client.request<RawCanned>(`/api/v1/canned_responses/${id}`, {
    method: 'PATCH',
    json: input,
  });
  return toCanned(raw);
}

export async function deleteCannedResponse(client: ApiClient, id: string): Promise<void> {
  await client.request<void>(`/api/v1/canned_responses/${id}`, { method: 'DELETE' });
}
